import {
  DEFAULT_FLEXIBLE_PROPERTIES_VIEW_MODE,
  FLEXIBLE_PROPERTIES_VIEW_MODE,
  type FlexiblePropertiesViewMode,
} from '../constants/FlexiblePropertiesConstants';
import QueryConstants from '../constants/QueryConstants';

import type { NextRouter } from 'next/router';

export type FlexiblePropertiesFilterState = {
  searchText: string;
};

export const defaultFlexiblePropertiesFilters: FlexiblePropertiesFilterState = {
  searchText: '',
};

const isValidViewMode = (value: string): value is FlexiblePropertiesViewMode =>
  Object.values(FLEXIBLE_PROPERTIES_VIEW_MODE).includes(value as FlexiblePropertiesViewMode);

export const initializeFlexiblePropertiesFiltersFromRouter = (
  query: NextRouter['query'],
  defaults: FlexiblePropertiesFilterState = defaultFlexiblePropertiesFilters,
): FlexiblePropertiesFilterState => ({
  ...defaults,
  searchText: (query[QueryConstants.SEARCH_TEXT] as string) || defaults.searchText,
});

export const initializeViewModeFromRouter = (
  query: NextRouter['query'],
  defaultViewMode: FlexiblePropertiesViewMode = DEFAULT_FLEXIBLE_PROPERTIES_VIEW_MODE,
): FlexiblePropertiesViewMode =>
  isValidViewMode(query[QueryConstants.VIEW_MODE] as string)
    ? (query[QueryConstants.VIEW_MODE] as FlexiblePropertiesViewMode)
    : defaultViewMode;

export const initializeFlexiblePropertiesPageStateFromQuery = (query: NextRouter['query']) => ({
  filters: initializeFlexiblePropertiesFiltersFromRouter(query),
  viewMode: initializeViewModeFromRouter(query),
});
